export default "__VITE_ASSET__ec6c531e__"